import { isBlank } from 'lib/string';

import { authHeaders, betterFetch, CCS_URL } from './helper';

/**
 * gets svg text from svg image
 * @param {string} svgImageUrl - Image url
 * @returns {Promise<Response>} the reponse object
 */
export const getSvgString = function getSvgString(svgImageUrl) {
  const headers = authHeaders();
  if (
    isBlank(svgImageUrl) ||
    !svgImageUrl.trim().startsWith('http') ||
    !svgImageUrl.includes('.svg')
  ) {
    return Promise.reject(new Error('Invalid svg http/https Image Url'));
  }
  return betterFetch(`${CCS_URL}/amp/svgimagestring?imageUrl=${svgImageUrl}`, { headers });
};

/**
 * request image sizes for a list of image urls
 * @param {string} urlList - list of image urls
 * @returns {object} the reponse object
 */
export const calculateImageSize = async function getImageSize(urlList) {
  const headers = authHeaders();

  const payload = {
    imageUrlList: urlList
  };

  const options = {
    method: 'POST',
    headers,
    body: JSON.stringify(payload)
  };

  const imageSizes = await betterFetch(`${CCS_URL}/misc/size`, options);
  return imageSizes;
};

/**
 * remove duplicate Link URLs in a given array
 * @param {Array} linkURLlist - list of Link URLs to dedoop
 * @returns {Array} list of Link URLs after duplicates have been removed
 */
export const removeDuplicateUrls = function removeDuplicateUrls(linkURLlist) {
  const isSameLink = (link1, link2) => {
    // checks that coutryCode, site, and linkUrl without search params are the same
    if (typeof link1 === 'object' && typeof link2 === 'object') {
      return (
        link1.countryCode === link2.countryCode &&
        link1.site === link2.site &&
        link1.linkUrl.split('?')[0] === link2.linkUrl.split('?')[0]
      );
    }

    // compare strings directly without search params
    if (typeof link1 === 'string' && typeof link2 === 'string') {
      return link1.split('?')[0] === link2.split('?')[0];
    }

    // if the types don't match
    return false;
  };

  // use let to allow reassign
  let links = [...linkURLlist];

  // iterate through each unique link, filtering out duplicates as you go
  for (let i = 0; i < links.length; i++) {
    links = links.filter((link, index, linksArray) => {
      return index <= i || !isSameLink(linksArray[i], link);
    });
  }

  return links;
};

/**
 * validate the give list of LinkURLs via status code
 * @param {Array} linkURLlist - list of Link URLs to validate
 * @returns {object} the reponse object
 */
export const validateLinkURLs = async function validateLinkURLs(linkURLlist) {
  if (linkURLlist.length === 0) {
    return [];
  }

  const headers = authHeaders();

  const payload = {
    linkURLlist: removeDuplicateUrls(linkURLlist)
  };

  const options = {
    method: 'POST',
    headers,
    body: JSON.stringify(payload)
  };
  const linkURLsWithStatusCode = await betterFetch(`${CCS_URL}/misc/linkURL`, options);
  return linkURLsWithStatusCode;
};

/**
 * get the list of audience tags from S3
 * @returns {Array} the list of audience tags
 */
export const getAudienceTags = () => {
  const headers = authHeaders();
  const channelBrand = 'NORDSTROM';
  const requestId = 'canvas';
  const clientId = 'APP01630';

  const options = {
    method: 'GET',
    headers
  };
  return betterFetch(
    `${CCS_URL}/misc/audienceTags?channelBrand=${channelBrand}&requestId=${requestId}&clientId=${clientId}`,
    options
  );
};
